export enum OfferStatusClass {
  NEEDS_CONFIRMATION = 'needs_confirmation',
  PENDING_ACCEPTANCE = 'pending_acceptance',
  BOOKED_LOAD = 'booked_load',
  DECLINED_LOAD = 'declined_load',
  CANCELLED_LOAD = 'cancelled_load'
}

export enum OfferStatus {
  offer_extended_to_carrier = 'offer_extended_to_carrier',
  broker_countered_offer = 'broker_countered_offer',
  carrier_submitted_bid = 'carrier_submitted_bid',
  carrier_accepted_offer = 'carrier_accepted_offer',
  carrier_accepted_counter_offer = 'carrier_accepted_counter_offer',
  carrier_submitted_counter_offer = 'carrier_submitted_counter_offer',
  offer_confirmed_by_broker = 'offer_confirmed_by_broker',
  broker_accepted_offer = 'broker_accepted_offer',
  broker_accepted_counter_offer = 'broker_accepted_counter_offer',
  broker_confirmed_offer = 'broker_confirmed_offer',
  carrier_declined_offer = 'carrier_declined_offer',
  broker_rescinded_offer = 'broker_rescinded_offer',
  broker_declined_counter_offer = 'broker_declined_counter_offer',
  offer_rescinded_by_broker = 'offer_rescinded_by_broker',
  broker_declined_offer = 'broker_declined_offer',
  carrier_offer_expired = 'carrier_offer_expired',
  carrier_counter_offer_expired = 'carrier_counter_offer_expired',
  carrier_declined_counter_offer = 'carrier_declined_counter_offer',
  offer_expired = 'offer_expired',
  broker_cancelled_load = 'broker_cancelled_load'
}

// Map the backend statuses to their respective OfferStatusClass
export const offerStatusMap: { [key in OfferStatus]: OfferStatusClass } = {
  [OfferStatus.offer_extended_to_carrier]: OfferStatusClass.PENDING_ACCEPTANCE,
  [OfferStatus.broker_countered_offer]: OfferStatusClass.PENDING_ACCEPTANCE,
  [OfferStatus.carrier_submitted_bid]: OfferStatusClass.NEEDS_CONFIRMATION,
  [OfferStatus.carrier_accepted_offer]: OfferStatusClass.NEEDS_CONFIRMATION,
  [OfferStatus.carrier_accepted_counter_offer]: OfferStatusClass.NEEDS_CONFIRMATION,
  [OfferStatus.carrier_submitted_counter_offer]: OfferStatusClass.NEEDS_CONFIRMATION,
  [OfferStatus.offer_confirmed_by_broker]: OfferStatusClass.BOOKED_LOAD,
  [OfferStatus.broker_accepted_offer]: OfferStatusClass.BOOKED_LOAD,
  [OfferStatus.broker_accepted_counter_offer]: OfferStatusClass.BOOKED_LOAD,
  [OfferStatus.broker_confirmed_offer]: OfferStatusClass.BOOKED_LOAD,
  [OfferStatus.carrier_declined_offer]: OfferStatusClass.DECLINED_LOAD,
  [OfferStatus.broker_rescinded_offer]: OfferStatusClass.DECLINED_LOAD,
  [OfferStatus.broker_declined_counter_offer]: OfferStatusClass.DECLINED_LOAD,
  [OfferStatus.offer_rescinded_by_broker]: OfferStatusClass.DECLINED_LOAD,
  [OfferStatus.broker_declined_offer]: OfferStatusClass.DECLINED_LOAD,
  [OfferStatus.carrier_offer_expired]: OfferStatusClass.DECLINED_LOAD,
  [OfferStatus.carrier_counter_offer_expired]: OfferStatusClass.DECLINED_LOAD,
  [OfferStatus.carrier_declined_counter_offer]: OfferStatusClass.DECLINED_LOAD,
  [OfferStatus.offer_expired]: OfferStatusClass.DECLINED_LOAD,
  [OfferStatus.broker_cancelled_load]: OfferStatusClass.CANCELLED_LOAD
}

/**
 * @description Checks if the offer can be counter offered
 * @param status - The status of the offer
 * @param numCounterOffersRemaining - The number of counter offers remaining
 * @returns True if the offer can be counter offered, false otherwise
 */
export const canCounterOffer = (
  status: string,
  numCounterOffersRemaining: number
) => {
  return (
    [
      OfferStatus.carrier_submitted_bid,
      OfferStatus.carrier_submitted_counter_offer
    ].includes(status as OfferStatus) && numCounterOffersRemaining > 0
  )
}
